export default "__VITE_ASSET__cd831b8d__"